import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

// Your web app's Firebase configuration
const firebaseConfig = {
    // You can populate these if needed, but App Check usually only needs the app to be initialized
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_GCP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

let appCheck = null;

// console.warn("DEBUG: Checking App Check availability...");
// console.warn("DEBUG: NODE_ENV", process.env.NODE_ENV);
// console.warn("DEBUG: REACT_APP_ENABLE_APP_CHECK_DEV", process.env.REACT_APP_ENABLE_APP_CHECK_DEV);
// console.warn("DEBUG: REACT_APP_FIREBASE_APP_CHECK_SITE_KEY", process.env.REACT_APP_FIREBASE_APP_CHECK_SITE_KEY ? "EXISTS" : "MISSING");

// Only enable App Check in Production OR if explicitly enabled for Dev (defaulting to true for now since we are debugging)
const enableInDev = process.env.REACT_APP_ENABLE_APP_CHECK_DEV === 'true';
const disableGlobally = process.env.REACT_APP_DISABLE_APP_CHECK === 'true';

if ((process.env.NODE_ENV === 'production' || enableInDev) && !disableGlobally) {
    const siteKey = process.env.REACT_APP_FIREBASE_APP_CHECK_SITE_KEY;
    if (siteKey) {
        // Use self-signed custom provider for localhost if needed, or ReCaptchaEnterprise with localhost allowed
        // Since we added localhost to ReCaptcha Enterprise, we can use it directly.
        // For strictly local dev without hitting ReCaptcha servers, we'd use debug tokens, but this way is closer to prod.

        // Improve local dev experience: use Debug Token if strictly needed, but let's try real key first.
        if (process.env.NODE_ENV !== 'production') {
            // For localhost, enable debug token generation to bypass domain restrictions if reCAPTCHA fails
            // eslint-disable-next-line no-restricted-globals
            window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
        }

        appCheck = initializeAppCheck(app, {
            provider: new ReCaptchaEnterpriseProvider(siteKey),
            isTokenAutoRefreshEnabled: true
        });
        console.log("Firebase App Check initialized (Mode: " + process.env.NODE_ENV + ")");
    } else {
        console.warn("Firebase App Check skipped: REACT_APP_FIREBASE_APP_CHECK_SITE_KEY not set.");
    }
} else {
    // console.log("Firebase App Check skipped (dev mode).");
    // Optional: Use DebugProvider for localhost testing if needed:
    // import { CustomProvider } from "firebase/app-check";
    // window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
}

export { app, appCheck };
